import Vue from 'vue'
import Router from 'vue-router'
import Store from './store'

Vue.use(Router)
function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Discovery',
      component: lazyLoad('market/Home')
    },
    {
      path: '/business/:id',
      name: 'Business',
      component: lazyLoad('market/BusinessPage'),
      props: (route) => ({
        businessId: route.params.id
      })
    },
    {
      path: '/outlet/:id',
      name: 'Outlet',
      component: lazyLoad('market/OutletPage'),
      props: (route) => ({
        outletId: route.params.id,
        query: route.query,
        outletInfo: route.params.outletInfo
      }),
      children: [{
        path: 'cartitem/:itemNumber',
        name: 'OutletCartItem',
        components: {
          outlet: lazyLoad('market/catalog/ItemDialog')
        },
        props: (route) => ({
          itemNumber: route.params.itemNumber
        }),
        meta: {
          showModal: true
        }
      }, {
        path: 'item/:itemId',
        name: 'OutletItem',
        components: {
          outlet: lazyLoad('market/catalog/ItemDialog')
        },
        props: (route) => ({
          itemId: route.params.itemId
        }),
        meta: {
          showModal: true
        }
      }, {
        path: 'deal/:dealId',
        name: 'OutletDeal',
        components: {
          outlet: lazyLoad('market/catalog/DealDetailModal')
        },
        props: (route) => ({
          dealId: route.params.dealId
        }),
        meta: {
          showModal: true
        }
      }]
    },
    {
      path: '/outlet/:id/cart',
      name: 'OutletCart',
      component: lazyLoad('market/cart/Cart')
    },
    {
      path: '/outlet/:id/customer',
      name: 'OutletCustomerForm',
      component: lazyLoad('market/CustomerForm')
    },
    {
      path: '/outlet/:id/orderresult',
      name: 'OutletOrderResult',
      component: lazyLoad('market/cart/OrderResult')
    },
    {
      path: '/outlet/:id/orderstatus',
      name: 'OutletOrderStatus',
      component: lazyLoad('market/cart/OrderStatus')
    },
    {
      path: '/feedback/form',
      name: 'FeedbackPage',
      component: lazyLoad('feedback/FeedbackPage'),
      props: (route) => ({
        campaignParams: route.query
      })
    },
    {
      path: '/feedback/response',
      name: 'FeedbackResponse',
      component: lazyLoad('feedback/FeedbackResponse'),
      props: (route) => ({
        campaignParams: route.query
      })
    }
  ],
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  }
})

router.beforeEach((to, from, next) => {
  const resourceId = localStorage.getItem('resourceId')
  const user = localStorage.getItem('currentUser')
  let routeName = ''
  let query

  // Maintain resource context
  if (resourceId) {
    query = {
      resourceId: resourceId
    }
  }

  if (to && to.name) {
    if (to.name.includes('Outlet') && !Store.getters['catalog/isDataLoaded'] && to.name !== 'Outlet') {
      if (user && to.name !== 'Discovery' && !resourceId) {
        // market app in user context refresh to home
        routeName = 'Discovery'
      } else {
        // market app in outlet context refresh to outlet page
        routeName = 'Outlet'
      }
    }
    if (routeName) {
      return next({
        name: routeName,
        params: to.params,
        query: query
      })
    }
  }

  next()
})

export default router
